export class InitialisePaymentPlanResult {
        // EFT/CC properties
        supplierId?: string;
        url?: string;
        payAttemptId?: string;

        // NAB CC properties
        nabMerchant?: string;
        nabReferenceId?: string;
        nabPaymentAlert?: string;
        nabFingerPrint?: string;
        nabTimestamp?: string;
        nabCallbackUrl?: string;
        nabResultUrl?: string;

        // MW CC properties
        mwMerchant?: string;
        mwApiKey?: string;
        mwReferenceId?: string;

        // MANUAL/BPAY properties

        currency?: string;
        amount?: number;
        agencyBankName?: string;
        agencyBankAccName?: string;
        agencyBankAccNumber?: string;
        agencyBSBCode?: string;
        eftCode?: string;
        eftDescription?: string;
        eftParticulars?: string;
        eftReference?: string;
        swiftCode?: string;
        internationalBankBranch?: string;
        bpayBillerCode?: string;
        bpayReference?: string;
        payRefKey?: string;
}
